export default __webpack_public_path__ + "static/media/tqicon-10.3ee5c57a.svg";